import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import { useState } from "react";
import {
  Dashboard as DashboardIcon,
  School as SchoolIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon,
  AutoAwesome as AIIcon,
} from "@mui/icons-material";

export default function Community() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        Community Management
      </Typography>
      <Card sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="body1" sx={{ color: "#8395a7" }}>
          This section is under development.
        </Typography>
      </Card>
    </Box>
  );
}
